import React from 'react'

// import Footer from '../Components/Footer'
import HeroSection from 'components/HeroSection'
// import Footer from 'components/Footer'
import CarouselTools from 'components/CarouselTools'
import LandingNavBar from 'components/navbar/NavBar'
import LandingFooter from 'components/Footer/landingFooter'
// import CarouselTools from 'components/CarouselTools'

const Tools = () => {
  return (
    <>
      <LandingNavBar />

      <HeroSection>
        <h1 class="font-[Good_Times] font-normal text-2xl leading-[48px] tracking-[0] text-center align-middle capitalize">
          your Blockchain learning journey{' '}
        </h1>

        <h2 class="font-[Good_Times] font-normal text-[24px] leading-[40px] tracking-[0] text-center align-middle capitalize">
          has never been easier thanks to our <br /> exclusive tools
        </h2>
      </HeroSection>
      <CarouselTools />
      <LandingFooter />

      {/* <Footer /> */}
    </>
  )
}

export default Tools
